import React, { useState, useEffect, useMemo } from "react";
import RightIcon from "../../../../assests/images/Group 911.svg";
import PubNub from "pubnub";
import constants from "../../../../utils/constants";
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';

const CHANNEL = "quickbook-notify";

const QboSuccess = () => {
  const [pubnubStatus, setPubnubStatus] = useState("idle");
  const [isSuccess, setIsSuccess] = useState(null);

  const pubNub = useMemo(() => {
    return new PubNub({
      publishKey: constants.PUBNUB_PUBLISHKEY,
      subscribeKey: constants.PUBNUB_SUBSCRIBEKEY,
      uuid: constants.PUBNUB_UUID,
      autoNetworkDetection: true,
      restore: true,
    });
  }, []);
  useEffect(() => {
    const param = new URLSearchParams(window.location.search);
    const status = param.get("status");
    const reason = param.get("reason");

    if (status === "success") {
      setIsSuccess(true);
    } else if (status === "error") {
      setIsSuccess(false);
    } else {
      setIsSuccess(false);
    }
    let mounted = true;

    const accountId =
      sessionStorage.getItem("accountId") ||
      (JSON.parse(sessionStorage.getItem("userDetails") || "null") || {}).accountId ||
      null;

    const params = new URLSearchParams(window.location.search);
    const stateParam = params.get("state") || null;

    const message = {
      type: "QUICKBOOK_PAGE_SHOWN",
      time: Date.now(),
    };
    if (accountId) message.accountId = accountId;
    if (stateParam) message.state = stateParam;

    setPubnubStatus("starting");
    const listener = {
      status: (st) => {
        try {
          const category = st?.category;
          if (!mounted) return;
          if (category === "PNConnectedCategory" || category === "PNNetworkUpCategory") {
            setPubnubStatus("connected");
          }
        } catch (e) {}
      },
    };

    try {
      pubNub.addListener(listener);
      pubNub.subscribe({ channels: [CHANNEL] });
    } catch (e) {
      console.error("PubNub init error", e);
      setPubnubStatus("error");
    }

    const publishPromise = pubNub.publish({ channel: CHANNEL, message });
    if (publishPromise && typeof publishPromise.then === "function") {
      publishPromise
        .then((res) => {
          if (!mounted) return;
          console.debug("PubNub publish success", res, message);
          setPubnubStatus("published");
        })
        .catch((err) => {
          if (!mounted) return;
          console.error("PubNub publish error", err, message);
          setPubnubStatus("error");
        });
    } else {
      setPubnubStatus("published");
    }

    return () => {
      mounted = false;
      try {
        pubNub.unsubscribe({ channels: [CHANNEL] });
      } catch (e) {}
      try {
        pubNub.removeListener(listener);
      } catch (e) {}
      try {
        pubNub.stop();
      } catch (e) {}
    };
  }, [pubNub]);
  if (isSuccess === null) return null;
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        fontFamily: "Arial",
        background: "#f9f9f9",
      }}
    >
    {isSuccess ? (
        <img
          src={RightIcon}
          alt="success"
          width="80"
          style={{ marginBottom: 20 }}
        />
      ) : (
        <DisabledByDefaultIcon
          style={{
            fontSize: 80,
            color: "#ff0000ff",
            marginBottom: 20,
          }}
        />
    )}

      <h2>
        {isSuccess
          ? "QuickBook Verified Successfully"
          : "Quickbook configuration failed. Please go to your Profile page and try again!"}
      </h2>

      {isSuccess && (
        <p>
          Please go to <b>Profile</b> Page.
        </p>
    )}
    </div>
  );
};

export default QboSuccess;
